export default {
  "b2b.fixniPozadavkyBox.textErrorSmlouvaFixni":
    "Smlouva k vybranému projektu žádné fixní nároky neobsahuje",
  "b2b.fixniPozadavkyBox.textFixni": "Fixní",
  "b2b.fixniPozadavkyBox.textObdobi": "Období požadavků",
  "b2b.fixniPozadavkyBox.textVsechny": "Ostatní",
  "b2b.fixniPozadavkyBox.title": "Fáze požadavků",
  "b2b.fixniPozadavkyBox.titleClose": "Nyní není možné zadávat požadavky",
  "b2b.fixniPozadavkyBox.titleErrorClosed": "Nyní není možné zadávat požadavky",
  "b2b.fixniPozadavkyBox.titleErrorSmlouvaFixni":
    "Nyní je možné zadávat požadavky pouze na FIXNÍ nároky",
  "b2b.fixniPozadavkyBox.titleOpenFixni":
    "Nyní je možné zadávat požadavky na FIXNÍ nároky",
  "b2b.fixniPozadavkyBox.titleOpenVsechny": "Nyní je možné zadávat požadavky"
};
